export default __webpack_public_path__ + "static/media/psmedway-verde-branco.407c2680.svg";